import { Skeleton, TableCell, TableRow } from '@mui/material';
import { TableSkeletonProps } from './types';

export default function TableSkeleton({
  columns,
  ...other
}: TableSkeletonProps) {
  return (
    <TableRow {...other}>
      {columns.map((col) => (
        <TableCell
          key={String(col.key ?? col.id)}
          data-id={col.key ?? col.id}
          sx={{
            width: col.width ?? col.minWidth ?? '100%',
            maxWidth: col.width ?? col.minWidth,
            minWidth: col.minWidth,
            textAlign: col.align,
            paddingY: (p) => `${p.spacing(1)} !important;`,
            borderRight: '0 !important;',
            borderLeft: '0 !important;',
          }}
        >
          <Skeleton sx={{ width: '100%', height: 12 }} />
        </TableCell>
      ))}
    </TableRow>
  );
}
